import React from "react";
import { Outlet } from "react-router-dom";

const EditorialStoriesLayout = () => {
  return (
    <div>
      {/* You can add a header, filters, or search UI here */}
      <Outlet />
    </div>
  );
};

export default EditorialStoriesLayout;